import { Navigate, Outlet, useOutletContext } from 'react-router-dom'
import type { IProjectResponse } from '../../../../api/types'

/** Layout + guard: recommendations only for project editors (owner/admin). */
export const ProjectRecommendations = () => {
  const project = useOutletContext<IProjectResponse>()
  const canEdit = project.viewer?.permissions?.can_edit_content === true

  if (!canEdit) {
    return <Navigate to=".." replace />
  }

  return <Outlet context={project} />
}
